export const GOOGLE_MAPS_API_KEY = "AIzaSyCxbfclKEm9lCTGAhErthdjtC0r4KoxQ7E";
// export const GOOGLE_MAPS_API_KEY = "AIzaSyA8pcOL4g0yG9W9Ps6JzohgHhA0-ugfce0";

export const INTEREST_QUESTION_ID = "00000000-0000-0000-0000-000000000001";
export const INTEREST_QUESTION_ORDER = -1000;

export const CASH_REGISTER_FORM_MAX_QUESTIONS = 5;
// Online order given to a row that left the registration form but must keep its
// (eventId, order) uniqueness: frees the low slots for the online reorder
export const ONLINE_ORDER_SENTINEL = 100_000;

// Session cookie cache configuration
// The cookie cache stores session data to avoid DB queries on every request
export const SESSION_COOKIE_CACHE_MAX_AGE = 60 * 60;

// Cookie cache refresh threshold (updateAge) - refresh when this many seconds remain
// Default BetterAuth behavior: refresh at 80% of maxAge (20% remaining)
export const SESSION_COOKIE_CACHE_UPDATE_AGE = Math.floor(SESSION_COOKIE_CACHE_MAX_AGE * 0.6);

// Client-side session refresh interval
// Set to 50% of maxAge to call getSession before the updateAge threshold (60%)
export const SESSION_REFRESH_INTERVAL_MS = Math.floor(SESSION_COOKIE_CACHE_MAX_AGE * 0.5 * 1000);

// Entry notification limit per exhibitor per event
export const MAX_ENTRY_NOTIFICATIONS_PER_EVENT = 20;

export const MINIMUM_CARD_PAYMENT_CENTS = 100;
